import { Splash } from "./views/components";
import { client } from "./services/api/graphql/initialize";
import { I18nextProvider, useTranslation } from "react-i18next";
import { Provider as ReduxProvider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { ApolloProvider } from "@apollo/client";
import { ThemeProvider } from "styled-components";
import { COLORS, CssGlobalVariables, cssVariables } from "./base/style";
import { router } from "./router";
import store from "./store";
import { ConfigProvider } from "antd";
import { useEffect, useState } from "react";
import clarity from "./hooks/clarity";

const App = () => {
  const { i18n } = useTranslation();
  const [lng, setLng] = useState(i18n.language);

  useEffect(() => {
    const handleLanguageChange = (lng) => {
      setLng(lng);
      document.documentElement.lang = lng;
      document.documentElement.dir = ["fa", "ar", "ur", "he"].includes(lng)
        ? "rtl"
        : "ltr";
    };

    handleLanguageChange(i18n.language);

    i18n.on("languageChanged", handleLanguageChange);
    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, [i18n]);

  useEffect(() => {
    const store = JSON.parse(localStorage.getItem("garajmall"));

    if (store?.Login.is_login === true) {
      clarity(`${store?.Login.country_code}${store.Login.phone_number}`);
    }
  }, []);

  return (
    <ApolloProvider client={client}>
      <ReduxProvider store={store}>
        <ThemeProvider theme={cssVariables}>
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: COLORS.primary,
                fontFamily: lng === "en" ? "Proxima" : "NotoSansArabic",
                borderRadius: 10,
              },
              components: {
                Collapse: {
                  headerPadding: "12px 0px",
                  contentPadding: "4px 0px !important",
                },
                Button: {
                  primaryShadow: "none",
                },
                Table: {
                  fontSize: 12,
                },
              },
            }}
          >
            <CssGlobalVariables />
            <Splash />
            <I18nextProvider defaultNS="translation" i18n={i18n}>
              <RouterProvider router={router} />
            </I18nextProvider>
          </ConfigProvider>
        </ThemeProvider>
      </ReduxProvider>
    </ApolloProvider>
  );
};

export default App;
